import { PIK_ARENDA_LINK, REALTOR_SELECTION_LINK } from 'shared/constants/links';
import { NBSP } from 'shared/constants/symbols';
import type { TBanner } from 'shared/types/banner';
import { EDealType, EOfferType } from 'shared/types/features';
import { withCianMedium } from 'shared/utils/links';

interface ISobPreFooterBanners {
  mainBanner: TBanner;
  secondBanner?: TBanner;
}

export const getSobPreFooterBanners = (dealType: EDealType, offerType: EOfferType): ISobPreFooterBanners => {
  const mainBanner: TBanner = {
    title: 'Нужна помощь профессионала?',
    linkBtn: {
      url: withCianMedium(REALTOR_SELECTION_LINK, dealType),
      text: 'Обратитесь к риелтору',
    },
    imageClass: 'house',
  };

  const isRentApartment = dealType === EDealType.Rent && offerType === EOfferType.Apartment;

  if (!isRentApartment) {
    return { mainBanner };
  }

  return {
    mainBanner,
    secondBanner: {
      title: `Сдайте квартиру с${NBSP}Циан${NBSP}х${NBSP}ПИК-Аренда`,
      linkBtn: {
        url: PIK_ARENDA_LINK,
        text: 'Подробнее',
      },
      imageClass: 'keys',
    },
  };
};
